import axios from "axios";
import { API_URL } from "../../constants";

export const fetch = (companyId, filtersValue) => {
  const url = `${API_URL}/${companyId}/products/fetch`;
  return axios.post(url, { filtersValue }).then((response) => response.data);
};

export const post = (companyId, data) => {
  const url = `${API_URL}/${companyId}/products/post`;
  return axios.post(url, data).then((response) => response.data);
};

export const fetchById = (companyId, productId) => {
  const url = `${API_URL}/${companyId}/products/${productId}`;
  return axios.get(url).then((response) => response.data);
};
